import React, { useState, useRef, useEffect } from 'react';

const TenantDropdown = ({
  options = [],
  value,
  onChange,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // close on outside click
  useEffect(() => {
    if (!open) return;

    const handleClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const selected =
    options.find((t) => t.tenantUrl === value) || options[0] || null;

  const handleSelect = (tenant) => {
    onChange?.(tenant.tenantUrl);
    setOpen(false);
  };

  const renderLabel = (tenant) => {
    const cleanUrl = tenant.tenantUrl.replace(/^https?:\/\//, '');
    const isShared = tenant.type === 'booked';
    const isUser = tenant.type === 'user';

    return (
      <>
        {/* <span
          className={
            'tenant-dd-dot ' +
            (isShared ? 'tenant-dd-dot--shared' : isUser ? 'tenant-dd-dot--personal' : '')
          }
        /> */}
        <span className="tenant-dd-url">{cleanUrl}</span>
        {(isShared || isUser) && (
          <span
            className={
              'tenant-dd-badge ' +
              (isShared ? 'tenant-dd-badge--shared' : 'tenant-dd-badge--personal')
            }
          >
            {isShared ? 'Shared' : 'Personal'}
          </span>
        )}
      </>
    );
  };

  return (
    <div
      className={`tenant-dd-wrapper ${disabled ? 'is-disabled' : ''}`}
      ref={wrapperRef}
    >
      <button
        type="button"
        className="tenant-dd-trigger"
        onClick={() => !disabled && setOpen((o) => !o)}
      >
        {selected ? renderLabel(selected) : <span className="tenant-dd-placeholder">Select tenant</span>}
        <span className="tenant-dd-chevron" />
      </button>

      {open && !disabled && (
        <div className="tenant-dd-menu">
          {options.map((tenant) => {
            const isActive = tenant.tenantUrl === selected?.tenantUrl;
            return (
              <button
                key={tenant.tenantUrl}
                type="button"
                className={`tenant-dd-option ${isActive ? 'is-active' : ''}`}
                onClick={() => handleSelect(tenant)}
              >
                {renderLabel(tenant)}
              </button>
            );
          })}

          {options.length === 0 && (
            <div className="tenant-dd-empty">No tenants available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default TenantDropdown;
